import React from "react";
import { Phone, Mail, MapPin, Clock, Siren } from "lucide-react";
import { LogoLockup } from "@/components/Logo";
import { CONTACT, SERVICES } from "@/data/content";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] border-t border-white/10">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl py-16">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <LogoLockup inverted />
            <p className="mt-6 text-sm leading-relaxed text-white/50 max-w-xs">
              Honest, expert roofing for all of Arizona — Schuyler Corder's Blessed Roofing,
              proudly backed by the Pro West Roofing umbrella. Licensed, insured, and always one
              call away.
            </p>
            <a
              href={`tel:${CONTACT.phoneRaw}`}
              className="mt-6 inline-flex items-center gap-2 bg-[#D86C1E] hover:bg-[#B0551A] text-white font-heading font-bold text-sm uppercase tracking-wide px-5 py-3 transition-colors"
            >
              <Phone className="h-4 w-4" /> {CONTACT.phone}
            </a>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading font-bold uppercase tracking-wider text-white text-sm mb-5">
              Services
            </h4>
            <ul className="space-y-3">
              {SERVICES.map((s) => (
                <li key={s.id}>
                  <a
                    href="#services"
                    className="text-sm text-white/50 hover:text-[#D86C1E] transition-colors"
                  >
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading font-bold uppercase tracking-wider text-white text-sm mb-5">
              Company
            </h4>
            <ul className="space-y-3">
              <li><a href="#about" className="text-sm text-white/50 hover:text-[#D86C1E] transition-colors">About Schuyler</a></li>
              <li><a href="#why" className="text-sm text-white/50 hover:text-[#D86C1E] transition-colors">Why Choose Us</a></li>
              <li><a href="#testimonials" className="text-sm text-white/50 hover:text-[#D86C1E] transition-colors">Reviews</a></li>
              <li><a href="#area" className="text-sm text-white/50 hover:text-[#D86C1E] transition-colors">Service Area</a></li>
              <li><a href="#quote" className="text-sm text-white/50 hover:text-[#D86C1E] transition-colors">Free Quote</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading font-bold uppercase tracking-wider text-white text-sm mb-5">
              Get In Touch
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="h-4 w-4 text-[#D86C1E] mt-0.5 shrink-0" />
                <a href={`tel:${CONTACT.phoneRaw}`} className="text-sm text-white/50 hover:text-white">{CONTACT.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-4 w-4 text-[#D86C1E] mt-0.5 shrink-0" />
                <a href={`mailto:${CONTACT.email}`} className="text-sm text-white/50 hover:text-white break-all">{CONTACT.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 text-[#D86C1E] mt-0.5 shrink-0" />
                <span className="text-sm text-white/50">{CONTACT.city}<br />Serving all of Arizona</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="h-4 w-4 text-[#D86C1E] mt-0.5 shrink-0" />
                <span className="text-sm text-white/50">{CONTACT.hours}</span>
              </li>
              <li className="flex items-start gap-3">
                <Siren className="h-4 w-4 text-[#D86C1E] mt-0.5 shrink-0" />
                <span className="text-sm text-white/50">{CONTACT.emergency}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} Blessed Roofing · Schuyler Corder. Backed by Pro West Roofing. All rights reserved.
          </p>
          <p className="text-xs text-white/40">
            Licensed &amp; Insured · ROC Certified · Arizona Owned &amp; Operated
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
